import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyEmailPreferences = loadable(() => import(/* webpackChunkName: "content/emailpreferences" */ '.'));
